<template>
<div class="tab-inner-left" v-if="showLayout">
<!--  <div class="w-full">
    <h5>SELECT A SECTION TO CUSTOMIZE</h5>
    <select class="al-input" v-model="selected_layout">
      <option :value="layout.value" :key="index" v-for="(layout, index) in layout_list">{{layout.label}}</option>
    </select>
  </div>-->

  <div v-if="selected_layout === 0">
    <div class="form-module" v-if="main_background_switch">
        <h2>Background Style</h2>
        <div class="flex">
          <span>Image</span><vs-switch class="switch-button mx-2" v-model="main_background_switch" :vs-value="main_background_switch ? 'Image' : 'Color'" /><span>Color</span>
        </div>
        <p>Change the color of background. You can see how it will look on the right.</p>
        <div class="color-picker">
          <chrome-picker v-model="colors" @input="updateBackground"
                         :value="colors"/>
        </div>
    </div>
    <div class="form-module" v-else>
      <h2>Background Style</h2>
      <div class="flex">
        <span>Image</span><vs-switch class="switch-button mx-2" v-model="main_background_switch" :vs-value="main_background_switch ? 'Image' : 'Color'" /><span>Color</span>
      </div>
      <p>You can add background image instead of plain color.</p>
      <upload-image :required="true" :img_id="(this.main_background_url === '') ? null : this.main_background_url" :code="'Main background settings url'" :index="-1" :callback="main_bg_id_Uploaded" />
      <div v-if="false">
        <div>
          <p class="py-2">Background Position</p>
          <vs-radio v-model="main_background_position" vs-value="center center" class="mr-4">Center Center</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="center bottom" class="mr-4">Center Bottom</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="center top" class="mr-4">Center Top</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="right bottom" class="mr-4">Right Bottom</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="right center" class="mr-4">Right Center</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="right top" class="mr-4">Right Top</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="left bottom" class="mr-4">Left Bottom</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="left center" class="mr-4">Left Center</vs-radio>
          <vs-radio v-model="main_background_position" vs-value="left top" class="mr-4">Left Top</vs-radio>
        </div>
        <div>
          <p class="py-2">Background Size</p>
          <vs-radio v-model="main_background_size" vs-value="cover" class="mr-4">Cover</vs-radio>
          <vs-radio v-model="main_background_size" vs-value="contain" class="mr-4">Contain</vs-radio>
        </div>

      </div>
    </div>
  </div>
  <div v-if="selected_layout === 1" class="form-module">
    <h2>Main Title Style</h2>
    <p>Change the color of main text. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_slogan" @input="updateSlogan"
                     :value="colors_slogan"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('campaignSlogan')"
               type="number" v-model="slogan_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('campaignSlogan')" v-model="slogan_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 2" class="form-module">
    <h2>Sub Title Style</h2>
    <p>Change the color of award text. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_award" @input="updateAwardText" :value="colors_award"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('campaignAward')"
               type="number" v-model="award_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('campaignAward')" v-model="award_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 3" class="form-module">
    <h2>Form Input Labels Text Style</h2>
    <p>Change the color of labels. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_label" @input="updateLabel"
                     :value="colors_label"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('fieldList')"
               type="number" v-model="label_size"
               placeholder="Label Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('fieldList')" v-model="label_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 4" class="form-module">
    <h2>Submit Button Text Style</h2>
    <p>Change the color of submit button. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_submit" @input="updateSubmit"
                     :value="colors_submit"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('submitButton')"
               type="number" v-model="submit_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('submitButton')" v-model="submit_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 5" class="form-module">
    <h2>Submit Button Background Style</h2>
    <p>Change the color of submit button background. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_submit_background" @input="updateSubmitBackground"
                     :value="colors_submit_background"/>
    </div>
  </div>
  <div v-if="selected_layout === 6" class="form-module">
    <h2>Submit Sub Text Style</h2>
    <p>Change the color of submit sub text. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_submit_subtext" @input="updateSubmitSubtext"
                     :value="colors_submit_subtext"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('submitButton')"
               type="number" v-model="submit_subtext_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('submitButton')" v-model="submit_subtext_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 7" class="form-module">
    <h2>Custom Link Sub Title Style</h2>
    <p>Change the color of custom link title. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_custom_link_title" @input="updateCustomLinkTitle"
                     :value="colors_custom_link_title"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('customLink')"
               type="number" v-model="custom_link_title_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('customLink')" v-model="custom_link_title_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 8" class="form-module">
    <h2>Custom Link Button Text Style</h2>
    <p>Change the color of custom link button. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_custom_link" @input="updateCustomLink"
                     :value="colors_custom_link"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('customLink')"
               type="number" v-model="custom_link_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('customLink')" v-model="custom_link_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 9" class="form-module">
    <h2>Custom Link Button Background Style</h2>
    <p>Change the color of custom link button background. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_custom_link_background" @input="updateCustomLinkBackground"
                     :value="colors_custom_link_background"/>
    </div>
  </div>
  <div v-if="selected_layout === 10" class="form-module">
  <h2>Privacy Policy Text Style</h2>
  <p>Change the color of privacy policy text. You can see how it will look on the right.</p>
  <select class="al-input" @change="updateChange('privacy')" v-model="privacy_primary_bool">
    <option value="0">Main Text</option>
    <option value="1">Links</option>
  </select>
  <div v-if="privacy_primary_bool === '0'" class="color-picker flex">
    <chrome-picker v-model="colors_privacy" @input="updatePrivacy"
                   :value="colors_privacy"/>

    <div class="flex flex-col ml-4">
      <p>Text Size (px)</p>
      <input class="al-input"
             @input="updateChange('privacy')"
             type="number" v-model="privacy_primary_size"
             placeholder="Privacy Primary Text Size"  />

      <p>Text Weight</p>
      <select class="al-input"
              @change="updateChange('privacy')" v-model="privacy_primary_weight">
        <option>200</option>
        <option>400</option>
        <option>600</option>
        <option>800</option>
      </select>
    </div>
  </div>
  <div v-else class="color-picker flex">
    <chrome-picker v-model="colors_privacy" @input="updatePrivacy"
                   :value="colors_privacy"/>

    <div class="flex flex-col ml-4">
      <p>Text Size (px)</p>
      <input class="al-input"
             @input="updateChange('privacy')"
             type="number" v-model="privacy_secondary_size"
             placeholder="Privacy Primary Text Size"  />

      <p>Text Weight</p>
      <select class="al-input"
              @change="updateChange('privacy')" v-model="privacy_secondary_weight">
        <option>200</option>
        <option>400</option>
        <option>600</option>
        <option>800</option>
      </select>
    </div>
  </div>
</div>
  <div v-if="selected_layout === 11" class="form-module">
    <h2>Scratch Congratulations Style</h2>
    <p>Change the style of congratulations text. You can see how it will look on the right.</p>
    <div class="color-picker flex">
      <chrome-picker v-model="colors_congrats" @input="updateCongratz"
                     :value="colors_congrats"/>

      <div class="flex flex-col ml-4">
        <p>Text Size (px)</p>
        <input class="al-input"
               @input="updateChange('congrats')"
               type="number" v-model="congrats_size"
               placeholder="Award Text Size"  />

        <p>Text Weight</p>
        <select class="al-input"
                @change="updateChange('congrats')" v-model="congrats_weight">
          <option>200</option>
          <option>400</option>
          <option>600</option>
          <option>800</option>
        </select>
      </div>
    </div>
  </div>
  <div v-if="selected_layout === 12">
    <div class="form-module" v-if="scratch_background_switch">
      <h2>Scratch-Off Card Background Style</h2>
      <div class="flex">
        <span>Image</span><vs-switch class="switch-button mx-2" v-model="scratch_background_switch" :vs-value="scratch_background_switch ? 'Image' : 'Color'" /><span>Color</span>
      </div>
      <p>Change the color of main text. You can see how it will look on the right.</p>
      <div class="color-picker">
        <chrome-picker v-model="colors_scratch" @input="updateScratchBackground"
                       :value="colors_scratch"/>
      </div>
    </div>
    <div class="form-module" v-else>
    <h2>Scratch-Off Card Background Style</h2>
    <div class="flex">
      <span>Image</span><vs-switch class="switch-button mx-2" v-model="scratch_background_switch" :vs-value="scratch_background_switch ? 'Image' : 'Color'" /><span>Color</span>
    </div>
    <p>You can add background image instead of plain color.</p>
    <upload-image :required="true" :img_id="(this.scratch_background_url === '') ? null : this.scratch_background_url" :code="'Scratch background settings url'" :index="-1" :callback="scratch_bg_id_Uploaded" />
  </div>
  </div>
  <div v-if="selected_layout === 13" class="form-module">
    <h2>Scratch-Off Card Cover Image</h2>
    <p>You can add background image instead of stock image.</p>
    <upload-image :required="false"
                  :img_id="(this.scratch_cover_url === '') ? null : this.scratch_cover_url"
                  :code="'Scratch cover image url'" :index="-1"
                  :callback="scratch_cover_id_Uploaded" />
  </div>
  <div v-if="selected_layout === 14" class="form-module">
    <div class="form-module">
      <h2>Title Style</h2>
      <p>Change the color of "Rate Us" title. You can see how it will look on the right.</p>
      <div class="color-picker flex mt-2">
        <chrome-picker v-model="colors_rate_us" @input="updateRateUs"
                       :value="colors_rate_us"/>

        <div class="flex flex-col mt-4 ml-4">
          <p>Text Size (px)</p>
          <input class="al-input"
                 @input="updateChange('Rate')"
                 type="number" v-model="rate_size"
                 placeholder="Award Text Size"  />

          <p>Text Weight</p>
          <select class="al-input"
                  @change="updateChange('Rate')" v-model="rate_weight">
            <option>200</option>
            <option>400</option>
            <option>600</option>
            <option>800</option>
          </select>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { Chrome } from 'vue-color'

import UploadImage from '../../../../layouts/components/navbar/UploadImage'
export default {
  props: {
    dataVal: {
      type: Object
    },
    id: {
      type: String
    },
    selected_layout: {
      type: Number
    }
  },
  data () {
    return {
      layout_list: [
        {
          label: 'Select Your Option',
          value: -1
        },
        {
          label: 'Background Style',
          value: 0
        },
        {
          label: 'Main Title Style',
          value: 1
        },
        {
          label: 'Sub Title Style',
          value: 2
        },
        {
          label: 'Form Input Labels Text Style',
          value: 3
        },
        {
          label: 'Submit Button Text Style',
          value: 4
        },
        {
          label: 'Submit Button Background Style',
          value: 5
        },
        {
          label: 'Submit Sub Text Style',
          value: 6
        },
        {
          label: 'Custom Link Sub Title Style',
          value: 7
        },
        {
          label: 'Custom Link Button Text Style',
          value: 8
        },
        {
          label: 'Custom Link Button Background Style',
          value: 9
        },
        {
          label: 'Privacy Policy Text Style',
          value: 10
        },
        {
          label: 'Scratch Congratulations Style',
          value: 11
        },
        {
          label: 'Scratch-Off Card Background Style',
          value: 12
        },
        {
          label: 'Scratch-Off Card Cover Image',
          value: 13
        },
        {
          label: 'Rate Us Title Color',
          value: 14
        }
      ],
      main_bg: '',
      rate_us_color: '',
      scratch_bg: '',
      rewards: '',
      slogan_text_color: '',
      congrats_text_color: '',
      label_color: '',
      award_text_color: '',

      submit_subtext_color: '',
      submit_text_color: '',
      submit_bg_color: '',

      custom_link_text_color: '',
      privacy_primary_color: '',
      privacy_secondary_color: '',
      custom_link_bg_color: '',
      custom_link_title_text_color: '',
      main_background_size: 'contain',
      main_background_position: 'center center',
      main_background_url: '',
      scratch_background_url: '',
      scratch_cover_url: '',
      scratch_background_size: 'contain',
      scratch_background_position: 'center center',
      privacy_primary_bool: '0',
      main_background_switch: true,
      scratch_background_switch: true,
      showLayout: false,
      custom_link_title_size: 20,
      custom_link_title_weight: 400,
      custom_link_size: 20,
      custom_link_weight: 400,
      privacy_primary_size: 20,
      privacy_primary_weight: 400,
      privacy_secondary_size: 20,
      privacy_secondary_weight: 400,
      award_size: 20,
      award_weight: 400,
      congrats_size: 20,
      congrats_weight: 400,
      slogan_size: 20,
      slogan_weight: 400,
      submit_size: 20,
      submit_weight: 400,
      label_size: 20,
      label_weight: 400,
      submit_subtext_size: 20,
      submit_subtext_weight: 400,
      rate_size: 20,
      rate_weight: 400,
      colors_reward: {
        hex: '#000000'
      },
      colors_rate_us: {
        hex: '#000000'
      },
      colors: {
        hex: '#000000'
      },
      colors_scratch: {
        hex: '#000000'
      },
      colors_award: {
        hex: '#000000'
      },
      colors_congrats: {
        hex: '#000000'
      },
      colors_slogan: {
        hex: '#000000'
      },
      colors_custom_link: {
        hex: '#ffffff'
      },
      colors_custom_link_title: {
        hex: '#000000'
      },
      colors_privacy: {
        hex: '#000000'
      },
      colors_custom_link_background: {
        hex: '#f07514'
      },
      colors_submit: {
        hex: '#ffffff'
      },
      colors_submit_subtext: {
        hex: '#000000'
      },
      colors_label: {
        hex: '#000000'
      },
      colors_submit_background: {
        hex: '#f07514'
      }
    }
  },
  components: {
    UploadImage,
    'chrome-picker': Chrome
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.setData()
  },
  watch: {
    selected_layout () {
      switch (this.selected_layout) {
      case 0:
        this.$store.commit('SET_EDITING_NOW', 'preview')
        break
      case 1:
        this.$store.commit('SET_EDITING_NOW', 'campaignSlogan')
        break
      case 2:
        this.$store.commit('SET_EDITING_NOW', 'campaignAward')
        break
      case 3:
        this.$store.commit('SET_EDITING_NOW', 'fieldList')
        break
      case 4:
        this.$store.commit('SET_EDITING_NOW', 'submitButton')
        break
      case 5:
        this.$store.commit('SET_EDITING_NOW', 'submitButton')
        break
      case 6:
        this.$store.commit('SET_EDITING_NOW', 'submitButton')
        break
      case 7 || 8 || 9:
        this.$store.commit('SET_EDITING_NOW', 'customLink')
        break
      case 10:
        this.$store.commit('SET_EDITING_NOW', 'privacy')
        break
      case 11:
        this.$store.commit('SET_EDITING_NOW', 'congrats')
        break
      case 12:
        this.$store.commit('SET_EDITING_NOW', 'scratchBackground')
        break
      case 13:
        this.$store.commit('SET_EDITING_NOW', 'scratchCover')
        break
      case 14:
        this.$store.commit('SET_EDITING_NOW', 'Rate')
        break
      }
    },
    main_background_url () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    },
    main_background_position () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    },
    main_background_size () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    },
    scratch_background_url () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    },
    scratch_background_position () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    },
    scratch_background_size () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    },
    scratch_cover_url () {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    },
    main_background_settings () {
      return {
        url: this.main_background_url,
        position: this.main_background_position,
        size: this.main_background_size
      }
    },
    custom_link_title_settings () {
      return {
        color: this.custom_link_title_text_color,
        size: this.custom_link_title_size,
        weight: this.custom_link_title_weight
      }
    },
    scratch_background_settings () {
      return {
        url: this.scratch_background_url,
        position: this.scratch_background_position,
        size: this.scratch_background_size
      }
    },
    campaign_theme_local () {
      return {
        main: this.main_background_switch ? this.main_bg : this.main_background_settings,
        scratch: this.scratch_background_switch ? this.scratch_bg : this.scratch_background_settings,
        congrats: {
          color: this.congrats_text_color,
          size: this.congrats_size,
          weight: this.congrats_weight
        },
        award: {
          color: this.award_text_color,
          size: this.award_size,
          weight: this.award_weight
        },
        slogan: {
          color: this.slogan_text_color,
          size: this.slogan_size,
          weight: this.slogan_weight
        },
        custom_link: {
          color: this.custom_link_text_color,
          size: this.custom_link_size,
          weight: this.custom_link_weight,
          background: this.custom_link_bg_color,
          title: this.custom_link_title_settings
        },
        submit: {
          color: this.submit_text_color,
          size: this.submit_size,
          weight: this.submit_weight,
          background: this.submit_bg_color
        },
        privacy: {
          primary_color: this.privacy_primary_color,
          primary_size: this.privacy_primary_size,
          primary_weight: this.privacy_primary_weight,
          secondary_color: this.privacy_secondary_color,
          secondary_size: this.privacy_secondary_size,
          secondary_weight: this.privacy_secondary_weight
        },
        submit_subtext: {
          color: this.submit_subtext_color,
          size: this.submit_subtext_size,
          weight: this.submit_subtext_weight
        },
        labels: {
          color: this.label_color,
          size: this.label_size,
          weight: this.label_weight
        },
        rate: {
          color: this.rate_us_color,
          size: this.rate_size,
          weight: this.rate_weight
        },
        cover: this.scratch_cover_url,
        rewards: this.rewards
      }
    }
  },
  methods: {
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    setData () {
      const theme = JSON.parse(JSON.stringify(this.dataVal))
      console.log('theme', theme)
      if (this.isObject(theme.main)) {
        console.log('is object', this.isObject(theme.main))
        this.main_background_switch = false
        this.main_background_url = theme.main.url
      } else {
        console.log('no object')
        if (theme.main !== '') {
          this.main_bg = theme.main
          this.main_background_switch = true
          this.colors.hex = theme.main
        }
      }

      if (this.isObject(theme.scratch)) {
        console.log('is object', this.isObject(theme.scratch))
        this.scratch_background_switch = false
        this.scratch_background_url = theme.scratch.url
      } else {
        console.log('no object')
        if (theme.scratch !== '') {
          this.scratch_bg = theme.scratch
          this.scratch_background_switch = true
          this.colors_scratch.hex = theme.scratch
        }
      }

      if (theme.cover) {
        this.scratch_cover_url = theme.cover
      }

      if (this.isObject(theme.slogan)) {
        this.slogan_text_color = theme.slogan.color
        this.slogan_size = theme.slogan.size
        this.slogan_weight = theme.slogan.weight
        this.colors_slogan.hex = theme.slogan.color
      }

      if (this.isObject(theme.award)) {
        this.award_text_color = theme.award.color
        this.award_size = theme.award.size
        this.award_weight = theme.award.weight
        this.colors_award.hex = theme.award.color
      }
      if (this.isObject(theme.congrats)) {
        this.congrats_text_color = theme.congrats.color
        this.congrats_size = theme.congrats.size
        this.congrats_weight = theme.congrats.weight
        this.colors_congrats.hex = theme.congrats.color
      }
      if (this.isObject(theme.labels)) {
        this.label_color = theme.labels.color
        this.label_size = theme.labels.size
        this.label_weight = theme.labels.weight
        this.colors_label.hex = theme.labels.color
      }
      if (this.isObject(theme.submit)) {
        this.submit_text_color = theme.submit.color
        this.submit_bg_color = theme.submit.background

        this.colors_submit.hex = theme.submit.color
        this.colors_submit_background.hex = theme.submit.background

        this.submit_size = theme.submit.size
        this.submit_weight = theme.submit.weight
      }
      if (this.isObject(theme.submit_subtext)) {
        this.submit_subtext_color = theme.submit_subtext.color

        this.colors_submit_subtext.hex = theme.submit_subtext.color

        this.submit_subtext_size = theme.submit_subtext.size
        this.submit_subtext_weight = theme.submit_subtext.weight
      }
      if (this.isObject(theme.privacy)) {
        this.privacy_primary_color = theme.privacy.primary_color
        this.colors_privacy.hex = theme.privacy.primary_color
        this.privacy_primary_size = theme.privacy.primary_size
        this.privacy_primary_weight = theme.privacy.primary_weight

        this.privacy_secondary_color = theme.privacy.secondary_color
        this.privacy_secondary_size = theme.privacy.secondary_size
        this.privacy_secondary_weight = theme.privacy.secondary_weight

      }
      if (this.isObject(theme.rate)) {
        this.rate_us_color = theme.rate.color
        this.colors_rate_us.hex = theme.rate.color
        this.rate_size = theme.rate.size
        this.rate_weight = theme.rate.weight
      }
      if (this.isObject(theme.custom_link)) {
        this.custom_link_text_color = theme.custom_link.color
        this.custom_link_bg_color = theme.custom_link.background

        this.colors_custom_link.hex = theme.custom_link.color
        this.colors_custom_link_background.hex = theme.custom_link.background

        this.custom_link_size = theme.custom_link.size
        this.custom_link_weight = theme.custom_link.weight

        if (this.isObject(theme.custom_link.title)) {
          this.custom_link_title_text_color = theme.custom_link.title.color
          this.custom_link_title_size = theme.custom_link.title.size
          this.custom_link_title_weight = theme.custom_link.title.weight

          this.colors_custom_link_title.hex = theme.custom_link.title.color
        }
      }

      this.showLayout = true
    },
    updateChange (ref) {
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', ref)
    },
    updateLabel (value) {
      this.label_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'fieldList')
    },
    updateSlogan (value) {
      this.slogan_text_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'campaignSlogan')
    },
    updateCongratz (value) {
      this.congrats_text_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'congrats')
    },
    updateCustomLink (value) {
      this.custom_link_text_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'customLink')
    },
    updatePrivacy (value) {
      if (this.privacy_primary_bool === '0') {
        this.privacy_primary_color = value.hex
      } else {
        this.privacy_secondary_color = value.hex
      }
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'privacy')
    },
    updateSubmit (value) {
      this.submit_text_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'submitButton')
    },
    updateSubmitBackground (value) {
      this.submit_bg_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'submitButton')
    },
    updateSubmitSubtext (value) {
      this.submit_subtext_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'submitButton')
    },
    updateCustomLinkTitle (value) {
      this.custom_link_title_text_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'customLink')
    },
    updateCustomLinkBackground (value) {
      this.custom_link_bg_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'customLink')
    },
    updateAwardText (value) {
      this.award_text_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'campaignAward')
    },
    updateScratchBackground (value) {
      this.scratch_bg = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'scratchBackground')
    },
    updateRewards (value) {
      this.rewards = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'rewards')
    },
    updateBackground (value) {
      this.main_bg = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'preview')
    },
    updateRateUs (value) {
      this.rate_us_color = value.hex
      this.$store.commit('SET_CAMPAIGN_THEME', this.campaign_theme_local)
      this.$store.commit('SET_EDITING_NOW', 'Rate')
    },
    main_bg_id_Uploaded (result) {
      console.log('main bg', result)
      this.main_background_url = result
      this.$store.commit('SET_EDITING_NOW', 'preview')
    },
    scratch_bg_id_Uploaded (result) {
      console.log('scratch bg', result)
      this.scratch_background_url = result
      this.$store.commit('SET_EDITING_NOW', 'scratchBackground')
    },
    scratch_cover_id_Uploaded (result) {
      console.log('scratch bg', result)
      this.scratch_cover_url = result
      this.$store.commit('SET_EDITING_NOW', 'scratchCover')
    }
  }
}
</script>

<style lang="scss">
</style>

